import { render, staticRenderFns } from "./Manifest2.vue?vue&type=template&id=3fac555c&scoped=true"
import script from "./Manifest2.vue?vue&type=script&lang=js"
export * from "./Manifest2.vue?vue&type=script&lang=js"
import style0 from "./Manifest2.vue?vue&type=style&index=0&id=3fac555c&prod&scoped=true&lang=css"
import style1 from "./Manifest2.vue?vue&type=style&index=1&id=3fac555c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac555c",
  null
  
)

export default component.exports